module.exports = __webpack_public_path__ + "img/statistik-aktiv.90d0d790.svg";